<template>
<div>
    <footer>
        <div class="circle__blue--footer"></div>
        <div class="container--row">
            <div class="footer__social">
                <a href="https://ro-ro.facebook.com/Pufina.Puternica.si.Fina" target="_blank" rel="noopener noreferrer">
                    <img src="images/icons/fb.png" alt="Pufina Facebook Social">
                </a>
                <a href="https://www.youtube.com/channel/UCIHQ5yx7qYMsiqvuORjl3-g" target="_blank" rel="noopener noreferrer">
                    <img src="images/icons/youtube.png" alt="Pufina Facebook Social">
                </a>
            </div>
            <div class="footer__terms">
                <!-- <a class="footer__link" href="" target="_blank" rel="noopener noreferrer">Termeni și Condiții</a> -->
                <a class="footer__link" href="/docs/Regulament-Campanie-Distractie-in-Familie-cu-Pufina_autentificat.pdf" target="_blank" rel="noopener noreferrer">Regulament Campanie</a>
                <!-- <a class="footer__link" href="" target="_blank" rel="noopener noreferrer">Politica de Confidențialitate</a> -->
                <a class="footer__link" href="https://www.pufina.ro/wp-content/uploads/2018/12/Politica_Cookies_Pufina.pdf" target="_blank" rel="noopener noreferrer">Politica Cookies</a>
            </div>
        </div>
    </footer>
    <div class="eupopup eupopup-top"></div>
</div>
    
</template>

<script>
export default {}
</script>